/* eslint-disable default-param-last */
const initialState = {
  users: null
};

export default function TestReducer(state = initialState, action) {
  // console.log(action, 'reducer');
  switch (action.type) {
    case 'GET_USERS':
      return {
        ...state,
        users: action.payload
      };
    default:
      return state;
  }
}
